export default __webpack_public_path__ + "f0fe075b2df57a0e7a074af56a579652.coffee";